import { Observable } from 'rxjs';
import { SgButtonVariant, SgSize } from '../../models';
import { StatusTag } from '../enums/status-tag.enum';
import { SgLabelTextSize, SgLabelTextVariant } from '../sg-label/sg-label.component';

export type SgDialogLayout = 'horizontal' | 'vertical';
export type SgDialogIconType = 'material' | 'image';
export type SgDialogBadgeType = 'label' | 'status-tag';

export interface SgDialogBadge {
  type: SgDialogBadgeType;
  text: string;
  variant?: SgLabelTextVariant;
  statusTag?: StatusTag;
  labelSize?: SgLabelTextSize;
  statusTagSize?: 'small' | 'default';
  inverted?: boolean;
  withDot?: boolean;
}

export interface SgDialogData {
  title: string;
  description?: string;
  icon?: string;
  iconColor?: string;
  iconType?: SgDialogIconType;
  layout?: SgDialogLayout;
  titleBadges?: SgDialogBadge[];
  titleBadgeDivider?: boolean;
  okButton?: SgDialogButton;
  cancelButton?: SgDialogButton;
  /** Optional third button rendered at the LEFT of the footer (before the
   *  cancel/ok pair that floats right). Used for tertiary destructive actions
   *  e.g. "Exit demo" alongside Cancel + Save. */
  extraButton?: SgDialogButton;
  showCloseButton?: boolean;
  displayDontShowAgainCheckbox?: boolean;
  showTitleTooltipOnOverflow?: boolean;
  /** Removes the default 91px min-height on the slot-content area.**/
  compactSlot?: boolean;
}
export interface SgDialogButton {
  text: string;
  variant?: SgButtonVariant;
  size?: SgSize;
  disabled?: boolean;
  isLoading?: boolean;
  icon?: string;
  iconPosition?: 'start' | 'end';
  preventAutoClose?: boolean;
  onClick?: () => void | Promise<any> | Observable<any>;
}
export interface SgDialogResult {
  action: SgDialogAction;
  dontShowAgainChecked?: boolean;
}
export enum SgDialogAction {
  Ok = 'ok',
  Cancel = 'cancel',
  Close = 'close',
  /** Result emitted when the optional `extraButton` (third footer slot) closes
   *  the dialog — distinct from Cancel so callers using afterClosed() can tell
   *  a tertiary destructive action apart from a normal Cancel click. */
  Extra = 'extra',
}
